<template>
    <div v-hotkey="keyMap">
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" rel="stylesheet"
            integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x" crossorigin="anonymous">
        <div v-show="modal" id="myModal" class="modal" @click.self="changeModal" ref="modalContent">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>{{ title }}</h1>
                    <svg @click="changeModal" xmlns="http://www.w3.org/2000/svg" width="33" height="33"
                        viewBox="0 0 33 33" fill="none">
                        <path d="M8.25 24.75L24.75 8.25M8.25 8.25L24.75 24.75" stroke="#5C5C5C" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="modal-body">
                    <div class="left">
                        <img src="/img/doggo_max.png" />
                    </div>
                    <div class="right">
                        <p v-html="text">
                        </p>
                        <max-offer-client :numerator="numerator" :denominator="denominator"
                            :title="counter_title"></max-offer-client>
                        <div class="btns">
                            <div class="close" @click="changeModal">
                                Zatvoriť
                            </div>
                            <div class="buy" @click="buy">
                                Spravovať predplatné
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MaxOfferClient from '../../../layouts/Header/MaxOfferClient.vue';
export default {
    components: { MaxOfferClient },
    props: ['openModal', 'is_offer', 'is_client', 'is_users_small_team', 'is_users_large_team'],
    data() {
        return {
            modal: true,
            title: "",
            text: "",
            numerator: 0,
            denominator: 0,
            counter_title: ""
        }
    },
    mounted() {
        if (this.is_offer) {
            this.counter_title = "vytvorených ponúk"
            this.title = "Dosiahol si svoj limit ponúk"
            this.text = "V balíčku ZADARMO môžeš vytvoriť <br> <strong>maximálne 3 ponuky</strong>. Ak chceš pridať <br> ďalšiu, prejdi na vyšší balík. "
            this.numerator = 3
            this.denominator = 3
        }
        if (this.is_client) {
            this.counter_title = "vytvorených klientov"
            this.title = "Dosiahol si svoj limit klientov"
            this.text = "V balíčku ZADARMO môžeš vytvoriť <br> <strong>maximálne 3 klientov</strong>. Ak chceš pridať <br> ďalšieho, prejdi na vyšší balík. "
            this.numerator = 3
            this.denominator = 3
        }
        if (this.is_users_small_team) {
            this.counter_title = "využitých prístupov"
            this.title = "Dosiahol si svoj limit účtov"
            this.text = "V balíčku <strong>Malý tím</strong> môžeš vytvoriť <br> <strong>maximálne 5 účtov pre svoj tým.</strong> Ak <br>  chceš pridať ďalšieho, prejdi na vyšší  <br> balík. "
            this.numerator = 5
            this.denominator = 5
        }
        if (this.is_users_large_team) {
            this.counter_title = "využitých prístupov"
            this.title = "Dosiahol si svoj limit účtov"
            this.text = "V balíčku <strong>Veľký tím</strong> môžeš vytvoriť <br> <strong>maximálne 20 účtov pre svoj tým.</strong> Ak <br>  chceš pridať ďalšieho, prejdi na vyšší  <br> balík. "
            this.numerator = 20
            this.denominator = 20
        }
    },
    computed: {
        keyMap() {
            return {
                'F12': this.buy,
                'ctrl+shift+i': this.buy,
                'ctrl+shift+j': this.buy,
                'ctrl+shift+c': this.buy,
            }
        }
    },
    methods: {
        buy() {
            window.location.href = "/admin/subscriptions/dashboard"
        },
        changeModal() {
            this.modal = !this.modal
            if (this.modal) {
                this.$refs.videoRef.play();
            } else {
                document.documentElement.style.overflow = 'auto';
                this.$emit('closeModal', false);
            }
        },
    },
    watch: {
        'openModal': function () {
            if (this.openModal) {
                this.changeModal()
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');

* {
    font-family: 'Roboto', sans-serif;
}


.modal {
    display: block;
    position: fixed;
    z-index: 1089;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: rgba(33, 37, 65, 0.89);
    backdrop-filter: blur(5px);

    .modal-content {
        margin: 100px auto 100px auto;
        background: #F7F7F7;
        width: 674px;
        border-radius: 4px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);

        @media (max-width: 600px) {
            width: 95% !important;
            margin: 50px auto 50px auto;
        }

        .modal-line {
            width: 673px;
            height: 1px;
            background: #D73C78;

            @media (max-width: 600px) {
                width: 100% !important;
            }
        }

        .modal-header {
            margin: 35px auto 20px auto;
            width: 578px;
            display: flex;
            align-items: center;
            padding: 0;
            border: none;

            @media (max-width: 600px) {
                width: 100% !important;
            }

            h1 {
                width: 427px;
                height: 34px;
                text-align: left;
                font-family: Roboto;
                font-size: 29px;
                font-style: normal;
                font-weight: 300;
                line-height: normal;
                color: #212541;

                @media (max-width: 600px) {
                    width: 100% !important;
                }
            }

            svg {
                transition: transform .5s;

                &:hover {
                    cursor: pointer;
                    transform: scale(1.3);
                }
            }
        }

        .modal-body {
            padding: 0;
            background-color: #F7F7F7;
            display: flex;
            justify-content: center;
            gap: 20px;

            .left {
                img {
                    width: 200px;
                }
            }

            .right {
                display: flex;
                flex-direction: column;
                justify-content: center;
                gap: 8px;

                p {
                    font-family: Montserrat;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 20px;
                    color: #6B6F8C;

                    strong {
                        font-weight: 900;
                    }
                }

                .btns {
                    display: flex;
                    align-items: center;
                    gap: 20px;

                    .close {
                        width: 83px;
                        height: 47px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 2px solid #E5E7EB;
                        border-radius: 8px;
                        font-family: Montserrat;
                        font-weight: 700;
                        font-size: 14px;
                        line-height: 20px;
                        color: #000000;
                        cursor: pointer;
                    }

                    .buy {
                        width: 169px;
                        height: 47px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: #2ED8B6;
                        border-radius: 8px;
                        font-family: Montserrat;
                        font-weight: 700;
                        font-size: 14px;
                        line-height: 20px;
                        color: #fff;
                        cursor: pointer;

                        &:hover {
                            background-color: #29c2a3;
                        }
                    }
                }
            }
        }
    }
}
</style>
